<template>
    <div :class="log.created_at === log.updated_at ? 'bg-gray-300 dark:bg-gray-600 text-gray-900 dark:text-gray-200' : (log.allowed === false ?  'bg-red-200 text-black' : 'bg-green-200 text-black')"
        class="my-2 rounded-lg flex flex-col md:flex-row justify-center md:justify-start items-start md:items-center shadow p-2">
        <div class="flex flex-row flex-grow">
            <div class="inline-block h-10 w-10 rounded-full bg-red-100 mr-3"></div>
            <div class="flex flex-col">
                <span>{{ log.user.name }}</span>
                <span class="text-sm">{{ log.user.email }}</span>
            </div>
        </div>
        <div v-if="log.payload" class="flex mt-4 md:mt-0 flex-row flex-grow items-center">
            <button v-if="log.payload.ipLocation"
                    @click="openMapLocation(log.payload.ipLocation)"
                    class="p-2 h-10 w-10 rounded-full bg-blue-500 mx-3">
                <LocationMarkerIcon class="text-white"/>
            </button>
            <div class="flex flex-col">
                <span>{{ log.payload.ipLocation.city?.name ?? "City N/A" }}, {{ log.payload.ipLocation.country?.name ?? "Country N/A" }}</span>
                <span class="text-sm">{{ log.payload.browserName }} v{{log.payload.browserVersion}} • {{ log.payload.os }} {{ log.payload.osVersion }}</span>
                <span v-if="log.payload.incognito" class="text-sm">Incognito Mode</span>
            </div>
        </div>
        <div class="flex mt-4 md:mt-0 flex-row w-full md:w-auto items-center justify-end">
            <button v-if="log.created_at === log.updated_at || log.allowed === false"
                    class="p-2 rounded-full bg-green-500 mx-3"
                    @click="$emit('approved')">
                <BadgeCheckIcon class="h-5 w-5 text-white"/>
            </button>
            <button v-if="log.created_at === log.updated_at || log.allowed === true"
                    class="p-2 rounded-full bg-red-500 mx-3"
                    @click="$emit('rejected')">
                <BanIcon class="h-5 w-5 text-white"/>
            </button>
        </div>
    </div>
</template>

<script>
import { BanIcon, BadgeCheckIcon, LocationMarkerIcon } from "@heroicons/vue/solid";

export default {
    props: {
        log: Object
    },
    components: {
        BanIcon,
        BadgeCheckIcon,
        LocationMarkerIcon,
    },
    emits: ['rejected', 'approved'],
    methods: {
        openMapLocation(location) {
            window.open(`https://maps.google.com/?q=${location.latitude},${location.longitude}`, '_blank').focus();
        }
    }
}
</script>
